<div class="flex justify-end my-4" *ngIf="!viewDisable">
  <button
    mat-flat-button
    type="button"
    (click)="openItemProcessModal()"
    class="!bg-green-600 !text-white rounded-none shadow-md"
  >
    ADD ITEMS +
  </button>
</div>

<ng-container *ngIf="itemGroups.length > 0">
  <mat-accordion multi>
    <ng-container *ngFor="let group of itemGroups; trackBy: trackByGroupName">
      <mat-expansion-panel [expanded]="group.dataSource.data.length > 0">
        <mat-expansion-panel-header [ngClass]="group.color" class="py-2 mb-2 !px-4">
          <div class="text-white flex justify-between items-center">
            <div class="text-lg">
              {{ group.name }}
            </div>
          </div>
        </mat-expansion-panel-header>

        <table mat-table [dataSource]="group.dataSource" class="w-full bg-white mat-elevation-z1">
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let row">{{ row.description }}</td>
          </ng-container>

          <ng-container matColumnDef="uniqueId">
            <th mat-header-cell *matHeaderCellDef>Unique ID</th>
            <td mat-cell *matCellDef="let row">{{ row.itemId }}</td>
          </ng-container>

          <ng-container matColumnDef="ID">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="formGroupMap.get(row.id) as fg; else idFallback">
                <div [formGroup]="fg">
                  <mat-form-field appearance="fill" class="w-20">
                    <input
                      matInput
                      formControlName="innerDiameter"
                      type="text"
                      inputmode="decimal"
                      pattern="^[0-9]*[.]?[0-9]*$"
                      (keypress)="onNumericKeyPress($event)"
                      [disabled]="viewDisable"
                      [style.cursor]="viewDisable ? 'not-allowed' : 'auto'"
                    />
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-template #idFallback>
                {{ row.innerDiameter }}
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="OD">
            <th mat-header-cell *matHeaderCellDef>OD</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="formGroupMap.get(row.id) as fg; else idFallback">
                <div [formGroup]="fg">
                  <mat-form-field appearance="fill" class="w-20">
                    <input
                      matInput
                      formControlName="outerDiameter"
                      type="text"
                      inputmode="decimal"
                      pattern="^[0-9]*[.]?[0-9]*$"
                      (keypress)="onNumericKeyPress($event)"
                      [disabled]="viewDisable"
                      [style.cursor]="viewDisable ? 'not-allowed' : 'auto'"
                    />
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-template #idFallback>
                {{ row.outerDiameter }}
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="pricePerUnit">
            <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('pricePerUnit') }}</th>
            <td mat-cell *matCellDef="let row">
              {{ row.pricePerUnit | formatCellValue: 'pricePerUnit' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="pricePerLb">
            <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('pricePerLb') }}</th>
            <td mat-cell *matCellDef="let row">
              {{ row.pricePerLb | formatCellValue: 'pricePerLb' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="lbsPer1000Ft">
            <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('lbsPer1000Ft') }}</th>
            <td mat-cell *matCellDef="let row">
              {{ row.lbPer1000ft | formatCellValue: 'lbPer1000ft' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="specificGravity">
            <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('specificGravity') }}</th>
            <td mat-cell *matCellDef="let row">
              {{ row.specificGravity | formatCellValue: 'specificGravity' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="constant1">
            <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('constant1') }}</th>
            <td mat-cell *matCellDef="let row">
              {{ row.constant1 | formatCellValue: 'constant1' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="constant2">
            <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('constant2') }}</th>
            <td mat-cell *matCellDef="let row">
              {{ row.constant2 | formatCellValue: 'constant2' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="surcharge">
            <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('surcharge') }}</th>
            <td mat-cell *matCellDef="let row">
              {{ row.pricePerLb | formatCellValue: 'pricePerLb' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="units">
            <th mat-header-cell *matHeaderCellDef>Units</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="formGroupMap.get(row.id) as fg; else unitsFallback">
                <div [formGroup]="fg">
                  <mat-form-field appearance="fill" class="w-20">
                    <input
                      matInput
                      formControlName="units"
                      type="text"
                      inputmode="decimal"
                      pattern="^[0-9]*[.]?[0-9]*$"
                      (keypress)="onNumericKeyPress($event)"
                      [disabled]="viewDisable"
                      [style.cursor]="viewDisable ? 'not-allowed' : 'auto'"
                    />
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-template #unitsFallback>
                {{ row.units }}
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="ftNeeded">
            <th mat-header-cell *matHeaderCellDef>FT Needed</th>
            <td mat-cell *matCellDef="let row">
              {{ row.ftNeeded | formatCellValue: 'ftNeeded' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="!text-right">
              <div
                class="hover:opacity-100"
                *ngIf="!viewDisable && !isOrdersManager() && !isOrdersAdmin()"
              >
                <button mat-icon-button (click)="removeRow(row, group)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="group.displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; let i = index; columns: group.displayedColumns"
            class="hover:bg-gray-50"
          ></tr>
        </table>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
</ng-container>
